module.exports = __webpack_public_path__ + "img/qklogo.0b44547f.png";